import Button from "react-bootstrap/Button";
import styled from "styled-components";
import parse from "html-react-parser";

const isHtml = (text) => {
  const div = document.createElement("div");
  div.innerHTML = text;
  return Array.from(div.childNodes).some((node) => node.nodeType === 1);
};

const StyledButton = styled(Button)`
  &.btn-secondary {
    display: flex;
    width: 315px;
    padding: 20px;
    justify-content: space-between;
    align-items: center;
    border-radius: 16px;
    border: 1px solid var(--Gray-300, #d0d5dd);
    background: var(--White, #fff);
    color: var(--alrajhi-Brand-1000, #000045);
    text-align: center;
    font-family: "Ping AR + LT";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    transition: all 0.3s ease;

    .button-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    .button-text {
      margin-right: 1.5rem;
      flex-wrap: wrap;
      display: flex;
      justify-content: center;
    }

    .bi {
      font-size: 24px;
      background-image: linear-gradient(180deg, #221afb 0%, #04007c 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      transition: color 0.3s ease, -webkit-text-fill-color 0.3s ease;
    }

    &:hover {
      transform: rotate(-6deg);
      background: linear-gradient(180deg, #221afb 0%, #04007c 100%);
      color: white;

      .bi {
        -webkit-text-fill-color: white;
      }
    }

    @media (max-width: 450px) {
      width: 100%;
      height: 15vh;

      &:hover {
        width: 100%;
        height: 15vh;
      }

      .button-content {
        display: flex;
        padding: 16px 32px;
        justify-content: space-between;
        align-items: center;
        width: 100%;
      }
    }
  }
`;

function ClickableButton({ text, onClick }) {
  return (
    <StyledButton variant="secondary" onClick={onClick}>
      <div className="button-content">
        <div className="button-text">{isHtml(text) ? parse(text) : text}</div>
        <i className="bi bi-arrow-right-circle"></i>
      </div>
    </StyledButton>
  );
}

export default ClickableButton;
